import { render } from "./Bet.vue?vue&type=template&id=9d2ed012&scoped=true"
import script from "./Bet.vue?vue&type=script&lang=js"
export * from "./Bet.vue?vue&type=script&lang=js"

import "./Bet.vue?vue&type=style&index=0&id=9d2ed012&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d2ed012"

export default script